<template>
	<v-container>
		<v-row>
			<v-col cols="7">
				<settlement-report-download-card :id="id" />
			</v-col>
			<v-col
				v-if="transactionId"
				v-can="'transaction.read'"
				cols="auto"
			>
				<v-card>
					<v-card-text>
						<v-btn
							color="primary"
							:href="`/bo/transactions/view?id=${transactionId}`"
							elevation="0"
						>
							<translate>
								Go to transaction
							</translate>
						</v-btn>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="paymentPsps">
			<v-col cols="7">
				<settlement-report-table :payment-psps="paymentPsps" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'SettlementReportOverview',
	props: {
		id: {
			type: String,
			required: true
		},
	},

	data () {
		return {
			paymentPsps: null,
			transactionId: null,
		};
	},

	created () {
		this.getInvoiceMonths();
	},

	methods: {

		/**
		 * Download ledger
		 */
		getInvoiceMonths () {
			axios.get(`/api/v0/adyensettlementreportfiles/${this.id}`)
				.then((response) => {
					if (response.data && response.data.adyenbatch) {
						this.paymentPsps = response.data.adyenbatch.paymentpaymentserviceproviders;
						this.transactionId = response.data.adyenbatch.transactionId;
					} else {
						displayError(this.$gettext('Something has gone wrong during data retrieval'));
					}
				})
				.catch((error) => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
					window.captureException(error);
				});
		},
	}
};
</script>
